
import { defineComponent } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'

export default defineComponent({
    components: {
        Loader,
        OkButton
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        loadingMessage: {
            type: String,
            default: 'Загрузка...'
        },
        failed: {
            type: Boolean,
            default: false,
        },
        failedMessage: {
            type: String,
            default: 'Произошла ошибка'
        }
    },
    emits: ['reload'],
    setup(props, { emit }) {
        const onReload = () => {
            if (props.loading) return
            emit('reload')
        }

        return {
            onReload
        }
    }
})
